<script>/* eslint-disable */</script>

<template>
  <div ref='stockDaysMarket' style='min-height:400px'></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'

export default {
  mounted () {
    this.createChart()
    this.loadData()
  },
  props: ['data'],
  data () {
    return {
      chart: null,
      title: null,
      selectedData: 'data'
    }
  },
  watch: {
  },
  methods: {
    loadData () {
      let length = this.chart.data.length
    
      
      this.chart.addData(this.data, length)
    },
    createChart () {
      this.chart = am4core.create(this.$refs.stockDaysMarket, am4charts.XYChart)

      let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = 'gudang'
      categoryAxis.title.text = "Number of stock in available in the warehouse"
      categoryAxis.numberFormatter.numberFormat = '#'
      categoryAxis.renderer.inversed = true
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.renderer.cellStartLocation = 0.1
      categoryAxis.renderer.cellEndLocation = 0.9
      

      let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis())
    //   valueAxis.renderer.opposite = true
      valueAxis.title.text = "Number of Vehicles"
      valueAxis.min = 0

      this.createSeries('stok', 'Number of vehicles in')
    },
    createSeries (field, name) {
      let series = this.chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.valueY = field
      series.dataFields.categoryX = 'gudang'
      series.name = name
      series.columns.template.tooltipText = '{name} {categoryX}: [bold]{valueY}[/]'
      series.columns.template.height = am4core.percent(100)
      series.sequencedInterpolation = true

      series.columns.template.adapter.add("fill", (fill, target)=>{
        return this.chart.colors.getIndex(target.dataItem.index);
      })
	  
      let valueLabel = series.bullets.push(new am4charts.LabelBullet())
      valueLabel.label.horizontalCenter = 'left'
      valueLabel.label.dx = 10
      valueLabel.label.hideOversized = false
      valueLabel.label.truncate = false

      let categoryLabel = series.bullets.push(new am4charts.LabelBullet())
      categoryLabel.label.horizontalCenter = 'right'
      categoryLabel.label.dx = -10
      categoryLabel.label.fill = am4core.color('#fff')
      categoryLabel.label.hideOversized = false
      categoryLabel.label.truncate = false
    }
  }
}
</script>
